export const AUTH_STORAGE_KEY = "tv2_skattelister_auth";
export const USER_EMAIL_STORAGE_KEY = "tv2_skattelister_email";

export const parserTypes = [
    {
        key: "CSV_PARSER",
        name: "CSV Parser",
    },
    {
        key: "FIXED_WITH_PARSER",
        name: "Fast Bredde Parser",
    },
];
